<script lang="ts">
  export let title: string
  export let cardStyles: string = ''
  export let textStyles: string = ''
</script>

<li
  class="{cardStyles} relative z-[3] flex h-[109px] w-[80%] max-w-[400px] items-center rounded-full border-2 border-black bg-[#24CAFF] text-center text-[18px] leading-[23.4px]"
>
  <p class="mx-auto w-[234px] font-graphik font-medium lg-desktop:leading-[26px] {textStyles}">
    {#each title.split(/<br\s*\/?>/) as line, index}
      {#if index > 0}<br />{/if}{line}
    {/each}
  </p>
</li>

<style lang="postcss">
  @media (min-width: 624px) {
    li:last-child {
      width: 40%;
      justify-self: center;
      grid-column: span 2 / span 2;
    }
  }

  @media (min-width: 768px) {
    li {
      width: 35vw;
    }

    li:last-child {
      grid-column-start: 1;
      grid-column-end: none;
      width: 35vw;
    }
  }

  @media (min-width: 1440px) {
    li {
      width: 290px;
      font-size: 20px;
    }
  }
</style>
